import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "round_phases" }
const _hoisted_2 = { style: {"line-height":"2em"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("ex.phases.title")), 1),
    _createElementVNode("ol", _hoisted_2, [
      _createElementVNode("li", null, _toDisplayString(_ctx.$t("ex.phases.breathing", { breathsPerRound: _ctx.breathsPerRound })), 1),
      _createElementVNode("li", null, _toDisplayString(_ctx.$t("ex.phases.hold")), 1),
      _createElementVNode("li", null, _toDisplayString(_ctx.$t("ex.phases.recovery", { recoveryTime: _ctx.recoveryTime })), 1)
    ])
  ]))
}